export default {"src":"/_next/static/media/diagram-boom.836aa6f8.svg","height":302,"width":348};